import { useRef } from 'react'
import {
  ScrollArea,
  ScrollAreaGradient,
} from '@valuecase/ui-components/src/components/ui/scroll-area'
import { AvatarThumbnail } from '@valuecase/ui-components/src/components/ui/avatar-thumbnail'
import { getCompanyInitials } from '@valuecase/common'
import { ReadSpacesListDTO } from '@/modules/spaces/hooks/types'

interface GradientListProps {
  spaces: ReadSpacesListDTO[]
}

const GradientSpacesList = ({ spaces }: GradientListProps) => {
  const viewportRef = useRef<HTMLDivElement>(null)

  return (
    <ScrollArea
      viewportRef={viewportRef}
      className='flex flex-col rounded-lg border border-grey-s2 bg-white overflow-hidden'
    >
      <div className='flex flex-col max-h-64 h-fit'>
        <div className='py-3 px-2 border-b border-grey-s2'>
          <h3 className='text-xs font-bold text-grey-s6'>Spaces</h3>
        </div>
        {spaces.map((space) => {
          const { archived, companyLogo, companyName } = space
          const initials = getCompanyInitials(companyName)?.toLowerCase()

          return (
            <div
              className='items-center py-4 px-2 gap-2 flex  border-b  border-grey-s2 last:border-b-0'
              key={space.rootNodeId}
            >
              {archived ? (
                <AvatarThumbnail type='icon' icon='archive' size={'LARGE'} />
              ) : companyLogo ? (
                <AvatarThumbnail type='image' imageUrl={companyLogo} size={'LARGE'} />
              ) : (
                <AvatarThumbnail type='gravatarInitials' initials={initials} size={'LARGE'} />
              )}
              <span key={space.rootNodeId} className='text-xs text-grey-s6 hover:bg-[#F9FBFF]'>
                {space.companyName}
              </span>
            </div>
          )
        })}
      </div>
      <ScrollAreaGradient scrollAreaRef={viewportRef} />
    </ScrollArea>
  )
}

export default GradientSpacesList
